import "./submit_for_review_toggle.scss"
import "./submit_for_review_toggle.coffee"
